import React from "react";
import "./AboutContent.css";

const AboutContentRight = ({
    className, 
    title, 
    subtitle, 
    body,
    image, 
    colorMode = "colorWhite",
    classSpacer
}) => {

    return (
        <>
            <div className={`column is-flex is-flex-direction-column is-justify-content-center ${className}`}>
                <div className="m-0 p-0 columns is-gapless is-variable">
                    {/* Photo widget on the right */}
                    <div className="hide-mobile m-0 p-0 column is-7-desktop is-12-mobile">
                        <div className="m-0 p-0 photo-widget-container">
                            {/* Main image */}
                            {image && (
                                <img 
                                    src={image} 
                                    alt="Kinder's"
                                    className="m-0 p-0 square-image" 
                                />
                            )}
                        </div>
                    </div>

                    <div className="column is-1 hide-mobile">  
                    </div>

                    <div className={`${classSpacer} column is-3`}>
                        <h2 className={`about ${colorMode}`}>{title}</h2>
                        <h3 className={`about ${colorMode}`}>{subtitle}</h3>
                        <p className={`about ${colorMode}`}>{body}</p>
                    </div>

                    
                    <div className="hide-desktop mt-5 p-0 column is-7-desktop is-12-mobile">
                        <div className="m-0 p-0 photo-widget-container">
                            {/* Main image */}
                            {image && (
                                <img 
                                    src={image} 
                                    alt="Kinder's"
                                    className="m-0 p-0 square-image" 
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AboutContentRight;